import { ItemsFormTable } from "./components/ItemsFormTable";
import { ItemsFormAddItem } from "./components/ItemsFormAddItem";

export const ItemsForm = () => (
  <div className="h-full px-8 py-8">
    <ItemsFormTable>
      <ItemsFormAddItem />
    </ItemsFormTable>
  </div>
);
